module.exports = __webpack_public_path__ + "img/SHM_side_top.610eed82.svg";